import React, {useState, useEffect} from 'react'
import CentralContentPageLayout from '../../Layout/CentralContentPageLayout'
import CentralGridLayout from '../../Layout/CentralGridLayout'
import PrivacyPolicy from '../../organism/PrivacyPolicy'
import styles from './index.module.scss';
import {  Grid } from '@mui/material'
import Typography from '@mui/material/Typography';
import { scaleByRatio } from '../../utils/helper';
import Box from "@mui/material/Box";
import { display } from '@mui/system';

const PrivacyPolicyPage = () => {
    useEffect(()=>{
        console.log('Privacy Policy Page')
    },[])
    const onBackClicked = () =>{
        console.log('Back clicked')
        window.history.back()
    }
    return ( 
        <>
        <CentralContentPageLayout>
        {/* <CentralGridLayout> */}
        <Box component="main" justifyContent="center" sx={{ 
            flexGrow: 1,
            pb:3, 
            pt:scaleByRatio(3), 
            margin:`auto`, 
            marginTop: `${scaleByRatio(-0)}px`,
            //pl:scaleByRatio(6)
            
        }}>
            <Grid container direction="row" justifyContent="center" alignItems="flex-end" xs={12} >
                <PrivacyPolicy 
                showAcceptButton={false}
                showPageName={true}
                maxheight={90}
                showBackbutton={true}
                onBackClicked={onBackClicked}
                />
            </Grid>
        </Box>
        {/* </CentralGridLayout> */}
        </CentralContentPageLayout>
    </>
     );
}
 
export default PrivacyPolicyPage;